/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TasksAssignee/view.blocks to change it.
import Content from './Content/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function TasksAssignee({
  children,
  onChange,
  assignee_id,
  viewPath = "/DesignSystem/TasksAssignee"
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
 onChange={onChange}
/>
{children}
</React.Fragment>)
}